export enum AuthModeEnum {
  PASSWORD = "PASSWORD",
  SSO = "SSO",
  OTP = "OTP",
}
